'use client';

import { createContext, type ReactNode, useContext } from 'react';

const CspNonceContext = createContext<string | undefined>(undefined);

interface CspNonceProviderProps {
  nonce: string;
  children: ReactNode;
}

/**
 * Provides the per-request CSP nonce from the edge proxy to client components
 * (e.g. JSON-LD scripts) that cannot call `headers()` directly.
 */
export function CspNonceProvider({ nonce, children }: CspNonceProviderProps) {
  return <CspNonceContext.Provider value={nonce}>{children}</CspNonceContext.Provider>;
}

export function useCspNonce(): string | undefined {
  return useContext(CspNonceContext);
}
